/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfBilling } from '../../models/data-page-of-billing';

export interface BillingLoadrecentdiagnosis$Params {
  emrpracticeId?: string | null;
  PatientId?: string | null;
}

export function billingLoadrecentdiagnosis(http: HttpClient, rootUrl: string, params?: BillingLoadrecentdiagnosis$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfBilling>> {
  const rb = new RequestBuilder(rootUrl, billingLoadrecentdiagnosis.PATH, 'get');
  if (params) {
    rb.query('emrpracticeId', params.emrpracticeId, {});
    rb.query('PatientId', params.PatientId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfBilling>;
    })
  );
}

billingLoadrecentdiagnosis.PATH = '/billing/recentdiagnosis';
